import { createStore, applyMiddleware, combineReducers } from 'redux'
import { thunk } from 'redux-thunk'
import generalDataReducer from './reducers/generalDataReducer'
import languageReducer from './reducers/languageReducer'
import sectionDataReducer from './reducers/sectionDataReducer'
import commitmentDataReducer from './reducers/commitmentDataReducer'
import feedbackDataReducer from './reducers/feedbackDataReducer'
import sectionMenuDataReducer from './reducers/sectionMenuDataReducer'
import loginDetailsReducer from './reducers/loginDetailsReducer'
import variablesReducer from './reducers/variablesReducer'
import sectionIndexReducer from './reducers/sectionIndexReducer'
import sectionHeadingReducer from './reducers/sectionHeadingReducer'

const rootReducer = combineReducers({
  generalData: generalDataReducer,
  language: languageReducer,
  sectionNames: sectionDataReducer,
  commitment: commitmentDataReducer,
  feedbackSections: feedbackDataReducer,
  sectionMenu: sectionMenuDataReducer,
  loginDetails: loginDetailsReducer,
  variables: variablesReducer,
  listHeading: sectionIndexReducer,
  sectionHeading: sectionHeadingReducer,
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store
